import React, { useState } from "react";
import { FaInstagram } from "react-icons/fa";
import emailjs from "emailjs-com";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    fullname: "",
    username: "",
    email: "",
    whatsapp: "",
    message: "",
  });
  const { fullname, username, email, whatsapp, message } = formData;

  const handleSubmit = (e) => {
    e.preventDefault();
    window.open(
      `https://api.whatsapp.com/send/?phone=62811121300&text=Halo%2C%20Saya%20${fullname}%20butuh%20informasi%20lebih%20lanjut%20tentang%20Paper%20Shoot%20Camera%0A%0A${message}%0A%0AMohon%20hubungi%20saya%20kembali%20via%0AWA%20${whatsapp}%0AEmail%20${email}%0ASocial%20Media%20${username}%0A%0AThank%20you`
    );

    // sendEmail(e);

    // window.open("mailto:admin@doss.co.id");
  };

  const handleEmail = () => {
    window.open(
      "mailto:" +
        "admin@doss.co.id" +
        "?subject=" +
        "Pemesanan Paper Shoot Camera" +
        "&body=" +
        `Halo%2C%20Saya%20${fullname}%20butuh%20informasi%20lebih%20lanjut%20tentang%20Paper%20Shoot%20Camera%0A%0A${message}%0A%0AMohon%20hubungi%20saya%20kembali%20via%0AWA%20${whatsapp}%0AEmail%20${email}%0ASocial%20Media%20${username}%0A%0AThank%20you`,
      "_self"
    );
  };

  return (
    <section id="contact">
      <div className="container contact">
        <div className="card">
          <div className="card-body">
            <h2 className="mb-3">Halo bestie!</h2>

            <div className="row gy-10 gx-lg-8 gx-xl-12">
              <div className="col-lg-8">
                <div className="lead mb-5">
                  Punya pertanyaan? Atau ingin punya Paper Shoot Camera?
                </div>
                <form
                  className="contact-form needs-validation"
                  onSubmit={handleSubmit}
                >
                  <div className="messages"></div>
                  <div className="row gx-4">
                    <div className="col-md-6">
                      <div className="form-floating mb-5">
                        <input
                          id="form_name"
                          type="text"
                          name="name"
                          className="form-control shadow-none"
                          placeholder="Nama Lengkap"
                          required
                          value={fullname}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              fullname: e.target.value,
                            })
                          }
                        />
                        <label htmlFor="form_name">Nama lengkap *</label>
                        <div className="valid-feedback">Looks good!</div>
                        <div className="invalid-feedback">
                          Mohon masukan nama kamu.
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating mb-5">
                        <input
                          id="form_lastname"
                          type="text"
                          name="surname"
                          className="form-control shadow-none"
                          placeholder="Akun Tiktok/Instagram"
                          value={username}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              username: e.target.value,
                            })
                          }
                        />
                        <label htmlFor="form_lastname">
                          Akun Tiktok/Instagram
                        </label>
                        <div className="valid-feedback">Looks good!</div>
                        <div className="invalid-feedback">
                          Mohon masukan username kamu
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating mb-5">
                        <input
                          id="form_email"
                          type="email"
                          name="email"
                          className="form-control shadow-none"
                          placeholder="jane.doe@example.com"
                          required
                          value={email}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              email: e.target.value,
                            })
                          }
                        />
                        <label htmlFor="form_email">Email *</label>
                        <div className="valid-feedback">Looks good!</div>
                        <div className="invalid-feedback">
                          Mohon masukan email kamu.
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating mb-5">
                        <input
                          id="whatsapp"
                          type="tel"
                          name="whatsapp"
                          className="form-control shadow-none"
                          placeholder="+62XXXXXX"
                          required
                          value={whatsapp}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              whatsapp: e.target.value,
                            })
                          }
                        />
                        <label htmlFor="whatsapp">Nomor Whatsapp*</label>
                        <div className="valid-feedback">Looks good!</div>
                        <div className="invalid-feedback">
                          Mohon masukan nomor kamu.
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                      <div className="form-select-wrapper mb-5">
                        <select
                          className="form-select shadow-none"
                          id="form-select"
                          name="subject-select"
                        >
                          <option selected disabled value>
                            Select a subject
                          </option>
                          <option value="Question">Question</option>
                          <option value="Pricing">Pricing</option>
                          <option value="Other">Other</option>
                        </select>
                        <div className="valid-feedback">Looks good!</div>
                        <div className="invalid-feedback">
                          Please enter your first name.
                        </div>
                      </div>
                    </div> */}
                    <div className="col-12">
                      <div className="form-floating mb-5">
                        <textarea
                          id="form_message"
                          name="message"
                          className="form-control shadow-none"
                          placeholder="Your message"
                          style={{ height: "150px" }}
                          required
                          maxLength={120}
                          value={message}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              message: e.target.value,
                            })
                          }
                        ></textarea>
                        <label htmlFor="form_message">Pesan *</label>
                        <div className="valid-feedback">Looks good!</div>
                        <div className="invalid-feedback">
                          Mohon masukan pesan kamu
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-check mb-5">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value
                          id="invalidCheck"
                          required
                        />
                        <label
                          className="form-check-label"
                          htmlFor="invalidCheck"
                        >
                          Saya setuju menerima informasi promosi dari Paper
                          Shoot Indonesia x DOSS
                        </label>
                        <div className="invalid-feedback">
                          Kamu harus setuju untuk lanjut.
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <input
                        type="submit"
                        className="btn btn-green-2 btn-send me-2"
                        value="KIRIM WA"
                      />
                      <input
                        type="button"
                        className="btn btn-green-3 btn-send"
                        value="KIRIM PESAN"
                        onClick={handleEmail}
                      />
                    </div>
                  </div>
                </form>
              </div>

              <div className="col-lg-4">
                <img
                  src="https://main.mobile.doss.co.id/storage/uploads/2022/08/form-image-w02.webp"
                  alt="form order"
                  className="w-100 d-block"
                />
                {/* <div className="d-flex flex-row">
                  <div>
                    <div className="icon text-white me-5 mt-1"></div>
                  </div>
                  <div>
                    <h5 className="mb-1">Address</h5>
                    <address>
                      Moonshine St. 14/05 Light City, London, United Kingdom
                    </address>
                  </div>
                </div>
                <div className="d-flex flex-row">
                  <div>
                    <div className="icon text-white me-5 mt-1"></div>
                  </div>
                  <div>
                    <h5 className="mb-1">Phone</h5>
                    <p>
                      00 (123) 456 78 90 <br />
                      00 (987) 654 32 10
                    </p>
                  </div>
                </div>
                <div className="d-flex flex-row">
                  <div>
                    <div className="icon text-white me-5 mt-1"></div>
                  </div>
                  <div>
                    <h5 className="mb-1">Email</h5>
                    <p>info@locus.com</p>
                  </div>
                </div> */}
              </div>
            </div>

            <h2 className="mt-10 mb-8 text-center">Follow Us on Instagram</h2>
            <div className="grid grid-view position-relative mb-10">
              <div
                className="position-absolute mt-3"
                style={{
                  top: "50%",
                  left: "50%",
                  zIndex: 2,
                  transform: "translate(-50%,-50%)",
                }}
              >
                <a
                  href="https://www.instagram.com/papershootstoreid/"
                  target="_blank"
                  className="btn btn-white d-flex flex-nowrap text-nowrap"
                >
                  <FaInstagram color="black" size={20} className="me-2" />{" "}
                  Follow Us
                </a>
              </div>
              <div className="row gx-md-6 gy-6 isotope opacity-75">
                <div className="item col-md-6 col-lg-3 contact-bg">
                  <figure className="rounded">
                    <img
                      src="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-24.webp"
                      srcSet="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-24.webp"
                      alt=""
                    />
                  </figure>
                </div>
                <div className="item col-md-6 col-lg-3 contact-bg">
                  <figure className="rounded">
                    <img
                      src="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-20.webp"
                      srcSet="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-20.webp"
                      alt=""
                    />
                  </figure>
                </div>
                <div className="item col-md-6 col-lg-3 contact-bg">
                  <figure className="rounded">
                    <img
                      src="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-12.webp"
                      srcSet="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-12.webp"
                      alt=""
                    />
                  </figure>
                </div>
                <div className="item col-md-6 col-lg-3 contact-bg">
                  <figure className="rounded">
                    <img
                      src="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-26.webp"
                      srcSet="https://main.mobile.doss.co.id/storage/uploads/2022/08/b-w-26.webp"
                      alt=""
                    />
                  </figure>
                </div>
              </div>
            </div>

            <p className="mb-0 text-center">
              © 2022 PT Global Sukses Digital. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
